import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectorRef,
} from "@angular/core";
import { Order, RXItem } from "src/app/shared/models/order.model";
import { BroshService } from "src/app/shared/services/brosh.service";
import { SharedService } from "src/app/shared/services/shared.service";
import { ChatService } from "src/app/shared/services/chat.service";
import { AuthService } from "src/app/shared/services/auth.service";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { ChatContact } from "src/app/shared/models/chat.model";
import { RouteEnum } from "src/app/shared/models/routes.model";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import {
  clinicList,
  currentOrder,
  doctorList,
  rxItems,
  stageList,
  ui_direction,
  qcModeSw,
} from "src/app/shared/ngrx/ngrx-selectors";
import { PopoverModule } from "primeng/popover";
import { OrderStageIconComponent } from "src/app/shared/components/order-stage-icon/order-stage-icon.component";
import { CommonModule } from "@angular/common";
import { OrderUrgencyIconComponent } from "src/app/shared/components/order-urgency-icon/order-urgency-icon.component";
import { TooltipModule } from "primeng/tooltip";
import { OrderProfilePrefComponent } from "../order-profile-pref/order-profile-pref.component";
import { SelectModule } from "primeng/select";
import { InputWrapComponent } from "src/app/shared/components/ui/input-wrap.component";
import { Clinic } from "src/app/shared/models/clinic.model";
import { FormsModule } from "@angular/forms";
import { DataElement, Doctor } from "src/app/shared/models/common";
import { DatePickerModule } from "primeng/datepicker";
import { map, switchMap, takeUntil, tap } from "rxjs/operators";
import { Actions, ofType } from "@ngrx/effects";
import {
  MARK_INBOX_NEEDS_RELOAD,
  RELOAD_CURRENT_ORDER,
  SELECT_INBOX_ORDER,
} from "src/app/shared/ngrx/ngrx-actions";
import { Subject } from "rxjs";
import { SpinnerComponent } from "src/app/shared/components/ui/spinner/spinner.component";
import { ClearMultiComponent } from "src/app/shared/components/ui/clear-multi.component";

@Component({
  selector: "order-header",
  templateUrl: "./order-header.component.html",
  styleUrls: ["./order-header.component.scss"],
  imports: [
    TranslateModule,
    PopoverModule,
    OrderStageIconComponent,
    CommonModule,
    OrderUrgencyIconComponent,
    TooltipModule,
    OrderProfilePrefComponent,
    SelectModule,
    FormsModule,
    InputWrapComponent,
    DatePickerModule,
    SpinnerComponent,
    ClearMultiComponent,
  ],
  standalone: true,
})
export class OrderHeaderComponent implements OnInit {
  @Output() onChatOpen = new EventEmitter<ChatContact>();

  plantUserSw: boolean;
  clinicUserSw: boolean;
  labUserSw: boolean;
  displayUrgency: boolean;
  routeEnum: RouteEnum = new RouteEnum();
  displayOrdTik: boolean;
  calLocale = {};
  editMode: boolean;
  allowEdit: boolean;
  destroy$ = new Subject();
  saving: boolean;
  defaultEditDate = new Date();
  editClinic?: Clinic;
  editDoctor?: Doctor;
  editStage?: DataElement;
  editPatient?: string;
  editShade?: string;
  editOrdScanNum?: string;
  editOrderDate?: Date;
  editDueDate?: Date;
  displayDoctorList: Doctor[] = [];
  displayAgent: boolean;
  displayTechnician: boolean;

  get clinicList(): Clinic[] {
    return this.store.selectSignal(clinicList)();
  }

  get doctorList(): Doctor[] {
    return this.store.selectSignal(doctorList)();
  }

  get qcModeSw(): boolean {
    return this.store.selectSignal(qcModeSw)();
  }


  get stageList(): DataElement[] {
    return this.store.selectSignal(stageList)();
  }

  get currentOrder(): Order {
    return this.store.selectSignal(currentOrder)();
  }

  get showFilesCarousel(): boolean {
    return this.router.url == "/main/inbox/order/rx";
  }

  get isNew(): boolean {
    return this.currentOrder.statusCode == "CLINIC_SIGNED";
  }

  get dir(): string {
    return this.store.selectSignal(ui_direction)();
  }

  get closedSw(): boolean {
    return this.currentOrder.mmdClosedSw;
  }

  constructor(
    private readonly store: Store,
    private broshService: BroshService,
    private sharedService: SharedService,
    private authService: AuthService,
    private actions$: Actions,
    private router: Router,
    private translateService: TranslateService
  ) {
    this.translateService.get("calLocale").subscribe((data) => {
      this.calLocale = data;
    });

    this.plantUserSw = this.authService.currentUser.isPlantUser;
    this.clinicUserSw = this.authService.currentUser.isClinicUser;
    this.labUserSw = this.authService.currentUser.isLabUser;
    this.displayUrgency =
      this.plantUserSw || this.authService.currentUser.isLabUser;
    this.displayAgent = this.labUserSw;
    this.displayTechnician = !this.plantUserSw;
    this.displayOrdTik = this.authService.currentUser.isLabUser;
    this.allowEdit = this.authService.currentUser.authDetails.getBooleanValue(
      "ORDERS.EDIT_HEADER_ALLOWED_SW"
    );
  }

  ngOnInit(): void {
    this.actions$
      .pipe(
        ofType(SELECT_INBOX_ORDER),
        takeUntil(this.destroy$),
        map(({ }) => {
          this.editMode = false;
          this.saving = false;
        })
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.destroy$.next(1);
  }

  onMarkFavorite() {
    let favoriteSw = !this.currentOrder.favoriteSw;
    this.broshService
      .updateOrderFavorite(this.currentOrder, favoriteSw)
      .subscribe(
        () => {
          this.currentOrder.favoriteSw = favoriteSw;
        },
        (error) => this.sharedService.alertError(error)
      );
  }

  onChatOpenClicked(contact: ChatContact) {
    this.onChatOpen.emit(contact);
  }

  filterDoctors() {
    if (this.editClinic) {
      this.displayDoctorList = this.doctorList?.filter((d) => {
        let inClinic = false;
        for (let i = 0; i < d.clinicList.length; i++) {
          inClinic = d.clinicList[i] == this.editClinic.id?.toString();
          if (inClinic) break;
        }
        return inClinic;
      });
    } else {
      this.displayDoctorList = [];
    }
  }

  headerEditClicked() {
    if (!this.editMode) {
      this.editClinic = this.clinicList?.find(
        (c) => c.clinicId == this.currentOrder.clinicId?.toString()
      );

      this.filterDoctors();

      this.editDoctor = this.displayDoctorList?.find(
        (c) => c.id == this.currentOrder.doctorId?.toString()
      );

      this.editStage = this.stageList?.find(
        (c) => c.id == this.currentOrder.stageId?.toString()
      );
      this.editPatient = this.currentOrder.patientFullName;
      this.editOrdScanNum = this.currentOrder.ordScanNum;
      this.editShade = this.currentOrder.shade;
      this.editOrderDate = this.currentOrder.orderDate;
      this.editDueDate = this.currentOrder.curDueDate;

      this.editMode = true;
    }
  }

  save(event) {
    event.stopPropagation();
    this.saving = true;
    this.broshService
      .updateOrderHeader(
        this.currentOrder.orderId,
        this.editClinic?.id,
        this.editDoctor?.id,
        this.editPatient,
        this.editOrderDate,
        this.editDueDate,
        this.editOrdScanNum,
        this.editShade,
        this.editStage?.id,
        this.qcModeSw
      )
      .subscribe(
        (data) => {
          if (data) {
            this.store.dispatch(
              RELOAD_CURRENT_ORDER({
                order: data,
              })
            );
            this.store.dispatch(MARK_INBOX_NEEDS_RELOAD());
          }

          this.editMode = false;
          this.broshService.sendOrderToMMD(this.currentOrder.orderId).subscribe(
            (data) => {
              this.saving = false;
            },
            (err) => {
              this.saving = false;
            }
          );
        },
        (err) => {
          this.saving = false;
        }
      );
  }

  cancelEdit(event) {
    event.stopPropagation();
    this.editMode = false;
  }
}
